import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../../../../src/Modulo_Responsive/Hooks/useResponsive";
import Tarjeta_Equipo from "../../Tarjetas/Tarjeta_Equipo";
import martha from "../../../../Recursos/martha.png"; // ajusta la ruta

const equipo = [
    {
        id: "1",
        nombre: "Martha Carolina",
        descripcion: "Arquitecta, diseñadora de interiores y también mamá. En Espacio Compacto Arquitectura entendemos lo que significa vivir o trabajar en espacios reducidos: la incomodidad, el caos, la sensación de que nada encaja.",
        imagen: martha,
        link: "/martha/"
    },
    // {
    //     id: "2",
    //     nombre: "Sst",
    //     descripcion: "Arquitecta, diseñadora de interiores y también mamá. En Espacio Compacto Arquitectura entendemos lo que significa vivir o trabajar en espacios reducidos: la incomodidad, el caos, la sensación de que nada encaja.",
    //     imagen: martha,
    //     link: "/equipo/martha-carolina"
    // }
];

const Lista_Equipo = () => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            size={{ xs: 12 }}
            sx={{ maxWidth: 1400, px: 3 }}
        >
            <Grid size={{ xs: 12 }} sx={{ mb: 12 }}>
                <Typography
                    component="h2"
                    variant={'h2'}
                >
                    Nuestro equipo
                </Typography>
            </Grid>

            <Grid container size={{ xs: 12 }} spacing={18}>
                {equipo.map((item) => (
                    <Grid key={item.id} size={{ xs: 12, sm: 12, md: 12 }}>
                        <Tarjeta_Equipo
                            imagen={item.imagen}
                            nombre={item.nombre}
                            descripcion={item.descripcion}
                            link={item.link}
                        />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};

export default Lista_Equipo;